export function allEquals(array: unknown[]): boolean {
  const firstElement = array[0];
  
  return array.every((element) => element === firstElement);
}

export function popElements<T>(array: T[], elements: T[]): T[] {
  return array.filter((value) => !elements.includes(value))
}
